<template>
    <div class="card h-100" style="min-height: 590px !important">
        <div class="border-0 card-header">
            <h2 class="mb-0">Issue Log</h2>
        </div>

        <el-table class="table-responsive table-flush"
                  header-row-class-name="thead-light"
                  :data="processedDrops">
            <el-table-column label="Date"
                             min-width="70px"
                             prop="name"
                             >
                <template v-slot="{row}">
                    <div class="media align-items-center">
                        <div class="media-body">
                            <span class="font-weight-600 name mb-0 text-sm">{{row.dateString}}</span>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="ID"
                             min-width="70px"
                             prop="id"
                             >
                <template v-slot="{row}">
                    <div class="media align-items-center">
                        <div class="media-body">
                            <span class="font-weight-600 name mb-0 text-sm">#{{row.id}}</span>
                        </div>
                    </div>
                </template>
            </el-table-column>
            

            <el-table-column label="Volunteer"
                             min-width="130px"
                             prop="volunteer"
                             >
                <template v-slot="{row}">
                   <div class=" text-nowrap">
                       <user-icon :firstName="row.volunteer.firstName" 
                                  :lastName="row.volunteer.lastName"
                                  :userId="row.userId"></user-icon>
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="Retailer" 
                             min-width="170px">
                <template v-slot="{row}">
                    <location-icon :logo="row.retailer.logoUrl" :avatarSize="'sm'" :name="row.retailer.name"></location-icon>
                </template>
            </el-table-column>

            <el-table-column label="Charity" 
                             min-width="170px">
                <template v-slot="{row}">
                    <location-icon :logo="row.charity.logoUrl" :avatarSize="'sm'" :name="row.charity.name"></location-icon>
                </template>
            </el-table-column>

            <el-table-column label="Arrival Time"
                             prop="completion"
                             min-width="130px"
                             >
                <template v-slot="{row}">
                    <div class="media align-items-center">
                        <div class="media-body">
                            <span class="font-weight-600 name mb-0 text-sm">{{row.completeDateString}}</span>
                        </div>
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="Status"
                             prop="status"
                             min-width="320px"
                             >
                <template v-slot="{row}">
                    <!-- <badge class="badge-dot mr-4" type="">
                        <i :class="`bg-${row.statusType}`"></i>
                        <span class="status">{{row.status}}</span>
                    </badge> -->
                    <button @click="onIssueNotesClick(row)" 
                          class="btn  btn-sm mt-1 btn-danger"
                         >
                      <i class="ni ni-chat-round"></i> Issue Notes
                    </button>
                     <button v-if="!row.issueResolved" class="btn btn-warning btn-sm mt-1 no-pointer" disabled="true">
                        <i class="ni ni-sound-wave"></i> Reported
                    </button>
                    <button v-if="row.issueResolved" class="btn btn-success btn-sm mt-1 no-pointer" disabled="true">
                        <i class="ni ni-check-bold"></i> Resolved
                    </button>
                </template>
            </el-table-column>
            
        </el-table>

        <div v-if="usePagination" class="card-footer py-4 d-flex justify-content-end">
            <base-pagination v-model="currentPage" :per-page="resultsPerPage" :total="drops.length"></base-pagination>
        </div>

        <!-- Issue modal -->
        <modal :show.sync="showModal">
          <template slot="header">
              <h5 class="modal-title" id="exampleModalLabel" v-if="issueModalDrop">Issue notes for drop #{{issueModalDrop.id}}</h5>
          </template>
          <div>
            <base-input>
              <textarea class="form-control" v-if="issueModalDrop" v-model="issueModalDrop.issueNote"></textarea>
            </base-input>
          </div>
          
          <template slot="footer">
              <base-button type="secondary" @click="showModal = false">Close</base-button>
              <base-button type="primary" @click="onIssueSaveClick()">Save changes</base-button>
          </template>
        </modal>
        <!-- End Issue modal -->
    </div>
</template>
<script>
  // Imports
  import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown} from 'element-ui';
  import UserIcon from '@/components/UserIcon';
  import LocationIcon from '@/components/LocationIcon';
  import Modal from '@/components/Modal';
  import moment from 'moment';
  import DropsService from '../../services/DropsService';
  import DropProcessor from '../../util/DropProcessor';
  //
  export default {
    name: 'retailer-lead-drops-with-issues-card',
    components: {
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      UserIcon,
      LocationIcon,
      Modal
    },

    props:[
        'usePagination',
        'resultsPerPage',
        'showReportIssueButton',
        'drops'
    ],

    data() {
      return {
        currentPage: 1,
        showModal: false,
        issueModalDrop: null
      };
    },
    
    computed:{
        processedDrops: function(){
            return DropProcessor.processDrops(this.currentPage, this.resultsPerPage, this.drops);
        }
    },
    methods: {
        moment: function () {
            return moment();
        },
        // Read the issue note
        onIssueNotesClick: async function(drop){
          this.issueModalDrop = drop;
          this.showModal = true;
        },
         // Read the issue note
        onIssueSaveClick: async function(){
          try{
            await DropsService.update(this.issueModalDrop.id, {issueNote: this.issueModalDrop.issueNote});
          }catch(err){
            alert('Sorry there was an error saving the issue')
          }
        }
    },

    watch:{
        currentPage: function(){
            //
        }
    }
  }
</script>